"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_2 = require("@remirror/react");
const ToolbarDropdownButton_1 = __importDefault(require("../../../../ui/ToolbarDropdownButton/ToolbarDropdownButton"));
const HeadingButton = ({ level }) => {
    const { toggleHeading } = (0, react_2.useCommands)();
    const chain = (0, react_2.useChainedCommands)();
    const active = (0, react_2.useActive)();
    const enabled = toggleHeading.enabled({ level });
    const handleSelect = () => {
        if (toggleHeading.enabled({ level })) {
            chain.toggleHeading({ level }).focus().run();
        }
    };
    const headingContent = () => {
        switch (level) {
            case 1:
                return react_1.default.createElement("h1", null, "Heading 1");
            case 2:
                return react_1.default.createElement("h2", null, "Heading 2");
            case 3:
                return react_1.default.createElement("h3", null, "Heading 3");
            case 4:
                return react_1.default.createElement("h4", null, "Heading 4");
            case 5:
                return react_1.default.createElement("h5", null, "Heading 5");
            case 6:
                return react_1.default.createElement("h6", null, "Heading 6");
        }
    };
    return (react_1.default.createElement(ToolbarDropdownButton_1.default, { handleOnClick: handleSelect, isDisabled: !enabled, isActive: active.heading({ level }), label: `Heading ${level}` }, headingContent()));
};
exports.default = HeadingButton;
